module.exports = __webpack_public_path__ + "static/media/gallery-drift.a7adeb43.jpg";